export const DIRECT_PAYMENT_CODE = "Direct Payment";
export const DIRECT_PAYMENT_DESCRIPTION = "Direct Payment";
